class CacheStorage {
  constructor() {
    this.CACHE_KEY_PREFIX = `socialtravel_${st.GLOBALS.APP_ENV}_`;
  }

  clear() {
    return (() => {
      let result = [];
      for (let i of __range__(0, (localStorage.length - 1), true)) {
        let item;
        let key = localStorage.key(i);
        if (key && key.indexOf(this.CACHE_KEY_PREFIX) === 0) {
          item = localStorage.removeItem(key);
        }
        result.push(item);
      }
      return result;
    })();
  }

  getItem(key) {
    return localStorage.getItem(`${this.CACHE_KEY_PREFIX}${key}`);
  }

  setItem(key, value) {
    return localStorage.setItem(`${this.CACHE_KEY_PREFIX}${key}`, value);
  }

  getObject(key) {
    let value;
    if (!(value = this.getItem(key))) { return; }
    return JSON.parse(value);
  }

  setObject(key, value) {
    return this.setItem(key, JSON.stringify(value));
  }
};

st.cache = new CacheStorage();



// WEBPACK FOOTER //
// ./app/webpack/frontend/common/CacheStorage.js